import { useCallback, useEffect, useRef, useState } from "react";

// Shared data-fetch hook that distinguishes LOADING / ERROR / DATA so a failed
// request is never silently turned into an empty financial state. Exposes a
// `reload` so the UI can offer a Retry control after a transient failure.
export function useAsyncData(fetcher) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mounted = useRef(true);
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const d = await fetcherRef.current();
      if (mounted.current) setData(d);
    } catch (e) {
      if (mounted.current) setError(e);
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}
